import React from 'react';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import { useAuth } from '../hooks/AuthContext';
import { apiService } from '../services/api';

interface AuthModalsProps {
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  isForgotPasswordModalOpen: boolean;
  closeModals: () => void;
  openRegisterModal: () => void;
  openLoginModal: () => void;
  openForgotPasswordModal: () => void;
  /**
   * Called after successful login/register instead of `closeModals`.
   * Use on /join-league to hide modals without navigating away so join runs on the same page.
   */
  onSuccessfulAuth?: () => void;
}

const AuthModals: React.FC<AuthModalsProps> = ({
  isLoginModalOpen,
  isRegisterModalOpen,
  isForgotPasswordModalOpen,
  closeModals,
  openRegisterModal,
  openLoginModal,
  openForgotPasswordModal,
  onSuccessfulAuth,
}) => {
  const { login, register } = useAuth();

  const handleForgotPassword = async (email: string) => {
    await apiService.forgotPassword(email);
  };

  const afterAuthSuccess = onSuccessfulAuth ?? closeModals;

  return (
    <>
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={closeModals}
        onLogin={login}
        onSwitchToRegister={openRegisterModal}
        onForgotPassword={openForgotPasswordModal}
        onSuccessfulLogin={onSuccessfulAuth ? afterAuthSuccess : undefined}
      />
      <RegisterModal
        isOpen={isRegisterModalOpen}
        onClose={closeModals}
        onRegister={register}
        onSwitchToLogin={openLoginModal}
        onSuccessfulRegister={onSuccessfulAuth ? afterAuthSuccess : undefined}
      />
      <ForgotPasswordModal
        isOpen={isForgotPasswordModalOpen}
        onClose={closeModals}
        onResetPassword={handleForgotPassword}
      />
    </>
  );
};

export default AuthModals;

export {}; 